import { Meal } from "@/clients/models/Meal";
import { MealTime } from "@/clients/models/MealTime";
import { CircleNotchIcon } from "@/components/icons/circle-notch-icon";
import { TextButton } from "@/components/ui/buttons";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";
import { AlternativeMealItem } from "./alternative-meal-item";

interface AlternativeMealsListProps {
  meals: Meal[];
  mealTime: MealTime;
  mealDay: string;
  mealIndex?: number;
  currentMealId?: string;
  targetDate?: string;
  requestId?: string | null;
  isLoading: boolean;
  isFetching: boolean;
  onClearSearch: () => void;
  onComplete?: () => void;
  onOpenMealDetail?: () => void;
  isExtra?: boolean;
}

export const AlternativeMealsList = memo(function AlternativeMealsList({
  meals,
  mealTime,
  mealDay,
  mealIndex,
  currentMealId,
  targetDate,
  requestId,
  isLoading,
  isFetching,
  onClearSearch,
  onComplete,
  onOpenMealDetail,
  isExtra,
}: AlternativeMealsListProps) {
  if (isLoading || isFetching) {
    return (
      <div className="mt-2 flex h-[338px] flex-col items-center justify-center gap-4">
        <p className={cn(textVariants.headline, "h-11.5")}>I'm searching :)</p>
        <CircleNotchIcon className="h-12 w-12 animate-spin" />
      </div>
    );
  }

  if (meals.length === 0) {
    return (
      <div className="flex flex-col items-center gap-4 py-8">
        <p className={cn(textVariants.body, "text-gray-600")}>No results found</p>
        <TextButton onClick={onClearSearch}>Try a different search</TextButton>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      {meals.map((meal, index) => (
        <AlternativeMealItem
          key={meal.id ?? index}
          meal={meal}
          mealTime={mealTime}
          mealDay={mealDay}
          mealIndex={mealIndex}
          currentMealId={currentMealId}
          targetDate={targetDate}
          requestId={requestId}
          onComplete={onComplete}
          onOpenMealDetail={onOpenMealDetail}
          selectedPosition={index}
          isExtra={isExtra}
        />
      ))}
    </div>
  );
});
